export default __webpack_public_path__ + "static/fire_door_w.6df90edf3b1152af3f62048f1d5fad0a.svg";